var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter__clear",class:{ disabled: _vm.disabled },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('font-awesome-icon',{attrs:{"icon":['far', 'times-circle'],"fixed-width":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }